import angular from 'angular'

import excel from './excel/excel.module'
import filters from './filters/filters.module'
import images from './images/images.service'
import httpInterceptor from './interceptors/httpInterceptor'
import sizeInterceptor from './interceptors/sizeInterceptor'
import requests from './requests/requests.module'
import utils from './utils/utils.module'

const name = 'serviceModule'

angular.module(name, [excel, filters, requests, utils,])
  .service('images', images)
  .service('httpInterceptor', httpInterceptor)
  .service('sizeInterceptor', sizeInterceptor)
  .config(['$httpProvider', ($httpProvider) => {
    $httpProvider.interceptors.push('httpInterceptor')
    $httpProvider.interceptors.push('sizeInterceptor')
  },])

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/service.module.js